import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'secure-layout',
    templateUrl: './secure-layout.component.html',
    styleUrls: ['./secure-layout.component.scss']
})
export class SecureLayoutComponent {
  constructor(private router: Router)
  {

  }

  logout() {
    localStorage.removeItem('authToken');
    this.router.navigateByUrl('/login')
  }
}
